import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import {Observable, of} from 'rxjs';
import {switchMap, catchError} from 'rxjs/operators';

import {User} from './user.model';
import {AuthPolicyService} from './auth-policy.service';

@Injectable()
export class VerifiedUserGuard implements CanActivate {
  constructor(
    private _authService: AuthPolicyService,
    private _router: Router,
  ) {}

  // Ensures a user has access to a route, if the user has at least one user type defined for that route.
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this._authService.getCurrentUser().pipe(
      switchMap((currentUser: User) => {
        return of(currentUser !== null);
      }),
      catchError((error, caught) => {
        if (error.status === 401 || error.status === 403) {
          // Access denied or forbidden
          console.log('user has no access');
          this._router.navigateByUrl('/survey/survey-list');
        }

        return of(false);
      }),
    );
  }
}
